<template>
  <div v-if="show">
    <div class="modal-overlay" @click="handleCancel"></div>
    <div class="modal-container">
      <div class="modal__header">
        <img class="modal__header-icon" :src="icon" alt="" />
        <h5 class="modal__header-title">{{ title }}</h5>
      </div>
      <p class="modal__content">{{ message }}</p>
      <div class="modal__actions">
        <button v-if="showCancel" class="modal__actions-button modal__actions-button--secondary" @click="handleCancel">
          {{ cancelText }}
        </button>
        <button class="modal__actions-button modal__actions-button--primary" @click="handleConfirm">
          {{ confirmText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: '',
    },
    confirmText: {
      type: String,
      default: 'OK',
    },
    cancelText: {
      type: String,
      default: 'Cancel',
    },
    showCancel: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    handleConfirm() {
      this.$emit('confirm');
    },
    handleCancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  &-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    background: rgba(0, 0, 0, 0.3);
  }

  &-container {
    z-index: 4;
    position: fixed;
    min-height: 13rem;
    width: 25rem;
    max-width: 75vw;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    right: 0;
    margin: auto;
    background: white;
    display: flex;
    padding: 2rem;
    flex-direction: column;
    justify-content: space-around;
    border-radius: 0.3rem;

    @media only screen and (max-width: 456px) {
      min-height: 16rem;
    }
  }

  &__header {
    display: flex;
    align-items: center;

    &-icon {
      width: 2.5rem;
    }

    &-title {
      font-size: 1.6rem;
      font-weight: normal;
      padding-left: 1rem;
      margin: 0;
      margin-top: 0.4rem;
    }
  }

  &__content {
    padding-left: 3.5rem;
    line-height: 1.5;
    margin: 0.5rem 0;
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
    margin: 0;
    margin-top: 1rem;

    &-button {
      margin-left: 0.5rem;
      padding: 0.6rem 1rem;
      border: none;
      text-transform: uppercase;
      border-radius: 0.25rem;
      color: white;
      cursor: pointer;
      font-weight: 500;

      &:hover {
        opacity: 0.9;
      }

      &--secondary {
        background: #aba9a9;
      }

      &--primary {
        background: #0065ae;
      }
    }
  }
}
</style>
